<template>
    
</template>

<script>
export default {
    name: 'coursejump',
    data() {
    },
    mounted(){
        window.location="https://www.bilibili.com/video/BV1Ls4y1o7Ym/?spm_id_from=333.999.0.0";
    },
}
</script>